import { useState, useEffect } from "react";

function getLocalStorageValue<T>(key: string, defaultValue: T): T {
  try {
    const val = localStorage.getItem(key);
    if (val === null || val === "undefined") {
      return defaultValue;
    }
    return JSON.parse(val);
  } catch (error) {
    console.warn(`Error parsing localStorage value for key "${key}":`, error);
    // Clear the invalid value and return default
    localStorage.removeItem(key);
    return defaultValue;
  }
}

export default function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState(() => {
    return getLocalStorageValue<T>(key, defaultValue);
  });

  useEffect(() => {
    // save the state if the value changes
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Error saving to localStorage for key "${key}":`, error);
    }
  }, [value]);

  useEffect(() => {
    // reload the state if the key changes
    setValue(getLocalStorageValue<T>(key, defaultValue));
  }, [key]);

  return [value, setValue] as const;
}
